class focusImages {
  constructor () {
    this.oTarget = $('#lh-f-i')
    this.oBox = this.oTarget.find('.lh-f-i-slick-box')
    this.oCurrentNumber = this.oTarget.find('.current')
    this.pageIndex = $('#page-5').length === 0 ? 6 : 7
    this.pageIndexName = $('#page-5').length === 0 ? '#sixth' : '#seventh'
    //  监听移入事件
    $(window).on('G2_onLeave', ev => {
      if (ev.nextIndex == this.pageIndex && !window.__focusPointImages) {
        this.init()
      }
    })
    
    //  加载进入
    if (window.hash == this.pageIndexName) {
      if (!window.__focusPointImages) {
        if (window.__fullPageInitEd) {  //  判断fullpage是否已经初始化了
          this.init()
        } else {
          $(window).on('G2_afterRender', ev => this.init())
        }
      }
    }
    
    if (window.preloadType == 'picture' || window.preloadType == 'poster') {
      this.init(true)
    }
    
    //  延迟加载
    window.setTimeout(() => {
      !window.__focusPointImages && this.init()
    }, window.gp_load_all)
    
    
    $(window).on('G2_onLeave', (ev) => {
      if (ev.nextIndex == this.pageIndex) {
        $('.mobile-picture-with-poster-trigger-box').velocity('fadeIn')
      } else {
        $('.mobile-picture-with-poster-trigger-box').velocity('fadeOut')
      }
    })
    
  }
  
  /**
   * 初始化
   * @param isPreload   是否为分享页面
   */
  init (isPreload = false) {
    if (window.__focusPointImages) {
      return false
    }
    window.__focusPointImages = true
    //  initHtml
    this.initHtml()
    
    //  处理分享页面
    if (isPreload) {
      let pictureNum = $('.picture-slider-for').get(0).dataset.total
      let posterNum = $('.poster-slider-for').get(0).dataset.total
      window.loadingBar.animate(0.3)
      if (window.preloadType == 'picture' && parseInt(window.preloadNum) <= pictureNum) {
        $(document.body).attr('type', 'picture')
        this.callPictureSlick()
        
      } else if (window.preloadType == 'poster' && parseInt(window.preloadNum) <= posterNum) {
        $(document.body).attr('type', 'poster')
        this.callPosterSlick()
      }
      window.loadingBar.animate(.6)
      
      //  跳转到当前页面
      $(window).one('G2_afterLoad', () => {
        window.loadingBar.animate(1)
        
        window.setTimeout(function () {
          //  切换至对应的num
          if (window.preloadType == 'picture') {
            $('.picture-slider-nav').find('.my_track').children().eq(window.preloadNum - 1).click()
          } else {
            $('.poster-slider-nav').find('.my_track').children().eq(window.preloadNum - 1).click()
          }
        }, 500)
        
      })
      $.fn.fullpage.moveTo(this.pageIndex)
    } else {
      $(document.body).attr('type', 'picture')
      this.callPictureSlick()
      window.loadingBar.animate(1)
      
    }
    
    //  poster picture toggle
    this.posterPictureToggle()
    
    //  prev - next btn event
    this.prevNextBtnEventHandle()
    
    //  mobile prev-right btn with prev-left btn both event handle
    this.mobileChangeBtnHandle()
    
    //  处理移动端兼容 author Buff modify 7:03 PM 3/28/2018
    this.mobileHack()
    
    $(window).on('G2_afterLoad', ev => {
      if (ev.index == this.pageIndex) {
        //  移動動畫
        if (window.innerWidth < window.gp_max_md) {
          $('.lh-f-i-title,.trigger,.slider-for,.lh-f-i .info')
          .velocity('transition.slideUpBigIn', {
            stagger: 80
          })
          $('.js-process-num-box-mobile').velocity('transition.slideUpBigIn', {
            display: 'flex',
            delay: 400
          })
        } else {  //  PC动画
          $('.lh-f-i .info')
          .velocity('transition.slideUpBigIn', {
            stagger: 80
          })
        }
      } else {
        if (window.innerWidth < window.gp_max_md) { //  移动动画
          $('.lh-f-i-title,.trigger,.slider-for,.lh-f-i .info')
          .css('opacity', 0)
        } else {  //  PC动画
          $('.lh-f-i .info')
          .css('opacity', 0)
        }
        
      }
    })
    
    //  添加下载按钮
    // this.download()
    
    //  默认分享链接
    let defaultShareLink = $('#lh-f-i .ziDingYi_style').get(0).dataset.a2aUrl
    $('.mobile-picture-with-poster-trigger-box .ziDingYi_style').get(0).dataset.a2aUrl = defaultShareLink
  }
  
  download () {
    let aDownload = $(`<a href="javascript:;" class="downloadImageIcon"><i class="icon-download-2"></i></a>`)
    $('#lh-f-i-share').append(aDownload)
    
    aDownload.on('click', () => {
      let src = window.__downloadTargetImage.src
      let fireName = $(document.body).attr('type')
      fireName = `${fireName}_${$('.js-lh-f-i-current').eq(0).text()}`
      
      //  拼凑有logo版本的链接
      let arr = src.split('focus-images')
      
      src = `${arr[0]}focus-images/logo${arr[1]}`
      
      var lrcLink = `https://tr.kingdomsalvation.org/wp-content/themes/gospel/gajax2/download.php?file=${src}&title=${fireName}`
      window.location.href = lrcLink
    })
  }
  
  mobileHack () {
    let style = $(`<style id="focusImagesMobileHack"></style>`)
    $('head').append(style)
    $(window).resize(() => {
      let MaxHeight = window.innerHeight - 139 - 21 - 22
      MaxHeight = MaxHeight > 768 ? 768 : MaxHeight
      
      let tabletPosterParentHeight = window.innerHeight - 170 - 80
      let mobilePosterParentHeight = window.innerHeight - 160
      
      style.html(`
        @media(min-width:${window.gp_max_md}px){
          .lh-f-i .poster-slider-for img{
            max-height: ${MaxHeight}px !important;
          }
        }
        @media(max-width:${window.gp_max_md - 1}px){
          .poster .lh-f-i-item{
            height:${tabletPosterParentHeight}px;
          }
        }
        @media(max-width:767px){
          .poster .lh-f-i-item{
            height:${mobilePosterParentHeight}px;
          }
        }
      `)
    })
    
    //  添加loading html代码
    $('.lh-f-i-slick-box').append(`<div class="lazyloading"><div class="preloader-wrapper big active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div></div>`);
    
    //  处理图片树横问题
    $('.poster img').map((k, el) => {
      let src = el.dataset.lazy
      $('<img/>') // Make in memory copy of image to avoid css issues
      .attr('src', src)
      .on('load', function () {
        let direction = this.width > this.height ? 'horizontal' : 'vertical'
        $(el).parent().addClass(`js-lh-${direction}`)
      })
      
    })
  }
  
  /**
   * 处理移动端左右切换btn 功能
   */
  mobileChangeBtnHandle () {
    this.oTarget.find('.info-btn').on('click', ev => {
      let el = ev.currentTarget
      let type = $(document.body).attr('type')
      let direction = ~el.className.indexOf('prev-left') ? 'left' : 'right'
      
      if (type == 'picture') {
        direction == 'left' ? $('.picture-slider-for .slick-prev').click() : $('.picture-slider-for .slick-next').click()
      } else {
        direction == 'left' ? $('.poster-slider-for .slick-prev').click() : $('.poster-slider-for .slick-next').click()
      }
      
    })
  }
  
  /**
   * for 的左右切换箭头事件绑定
   */
  prevNextBtnEventHandle () {
    $(document).on('click', '.lh-f-i .slick-next', ev => {
      let type = $(document.body).attr('type')
      let current = parseInt($('.js-lh-f-i-current').html().trim())
      let total = parseInt($('.js-lh-f-i-total').html().trim())
      
      //  切换海报或者图片
      console.log(1)
      if (current == total && window.innerWidth > window.gp_max_md && !window.gp2_is_rtl) {
        type == 'picture' ? $('.js-poster').click() : $('.js-picture').click()
      }
    })
    
    $(document).on('click', '.lh-f-i .slick-prev', ev => {
      let type = $(document.body).attr('type')
      let current = parseInt($('.js-lh-f-i-current').html().trim())
      
      //  切换海报或者图片
      let total = parseInt($('.js-lh-f-i-total').html().trim())
      if (current == total && window.innerWidth > window.gp_max_md && window.gp2_is_rtl) {
        type == 'picture' ? $('.js-poster').click() : $('.js-picture').click()
      }
    })
  }
  
  /**
   * 照片海报切换
   */
  posterPictureToggle () {
    $('.js-picture').on('click', () => {
      if (window.__limitPictrueWithPosterChange || $(document.body).attr('type') == 'picture') {
        return false
      }
      
      window.__limitPictrueWithPosterChange = true
      window.setTimeout(() => window.__limitPictrueWithPosterChange = false, 1000)
      
      $(document.body).attr('type', 'picture')
      //  call Picture
      if ($('.picture-slider-for').find('.slick-list').length == 0) {
        this.callPictureSlick()
      } else {
        window.setTimeout(() => {
          $('.picture-slider-nav').find('.my_track').children().eq(0).click()
          let obj = $('.picture-slider-for').get(0)
          this._changeTotalNum(this._getDoubleNumber(obj.dataset.total))
        }, 200)
      }
      $('.picture-slider-for').slick('setPosition')
      
      
    })
    
    $('.js-poster').on('click', () => {
      if (window.__limitPictrueWithPosterChange || $(document.body).attr('type') == 'poster') {
        return false
      }
      
      window.__limitPictrueWithPosterChange = true
      window.setTimeout(() => window.__limitPictrueWithPosterChange = false, 1000)
      
      $(document.body).attr('type', 'poster')
      //  call poster
      if ($('.poster-slider-for').find('.slick-list').length == 0) {
        this.callPosterSlick()
      } else {
        window.setTimeout(() => {
          $('.poster-slider-nav').find('.my_track').children().eq(0).click()
          let obj = $('.poster-slider-for').get(0)
          this._changeTotalNum(this._getDoubleNumber(obj.dataset.total))
        }, 200)
      }
      $('.poster-slider-for').slick('setPosition')
    })
    
    
  }
  
  /**
   * 修改分享链接
   * @private
   */
  _changeShareLink (num) {
    let obj = $('#lh-f-i .ziDingYi_style,.mobile-picture-with-poster-trigger-box .ziDingYi_style')
    obj.map((k, el) => {
      let host = `https://${window.location.host}${window.location.pathname}`
      el.dataset.a2aUrl = `${host}?type=${$(document.body).attr('type')}&num=${num}`
    })
    
  }
  
  /**
   * 返回 01 02 10 这种两位数字
   * @param num
   * @returns {any | *}
   * @private
   */
  _getDoubleNumber (num) {
    num = parseInt(num)
    num = num > 9 ? num : `0${num}`
    return num
  }
  
  /**
   * 修改描述 + 动画
   * @param desc
   * @param notIndent
   * @private
   */
  _changeDesc (desc, notIndent) {
    if (!desc || desc == '') {
      return false
    }
    if (window.innerWidth < window.gp_max_md) {
      let obj = $('.js-lh-f-i-desc')
      obj.children('p').remove()
      obj.append(`<p>${desc}</p>`)
      
      return
    }
    
    let obj = $('.js-lh-f-i-desc')
    let firstP = obj.children('p').eq(0)
    let secondP = $(`<p class="animate" notIndent="${notIndent}">${desc}</p>`)
    
    /* !! BUG !!
    	快速点击切换出现多行描述 Bug
    	@author - Buff
    	@date   - 3/1/2018
    	@time   - 4:24 PM
    */
    obj.children('p:not(.animate):not(:first-of-type)').remove()
    
    obj.append(secondP)
    firstP.velocity('fadeOut', {
      complete: () => {
        firstP.remove()
      }
    })
    secondP.velocity('fadeIn', {
      complete: () => {
        secondP.removeClass('animate')
      }
    })
  }
  
  /**
   * 修改 当前选中的current num + 动画
   * @param num
   * @param direction
   * @private
   */
  _changeCurrentNum (num, direction = 'right') {
    num = this._getDoubleNumber(num)
    let obj = $('.js-lh-f-i-current')
    
    if (window.innerWidth < 480) {
      obj.html(num)
      return
    }
    
    let translateY = direction == 'right' ? -20 : 20
    let sequence = [
      {
        e: obj,
        p: {scaleX: [0.8, 1], translateY: [translateY, 0], opacity: [0, 1]},
        o: {duration: 200, delay: 200, easing: 'easeInQuad', complete: () => obj.html(num)}
      },
      {
        e: obj,
        p: {translateY: [0, -translateY], opacity: [1, 0], scaleX: [1, 0.8]},
        o: {duration: 200, delay: 200, easing: 'easeOutQuad'}
      },
    ]
    obj.velocity('finish')
    obj.stop(false, true)
    $.Velocity.RunSequence(sequence)
  }
  
  /**
   * 修改 总数 + 动画
   * @param num
   * @private
   */
  _changeTotalNum (num) {
    let obj = $('.js-lh-f-i-total')
    num = this._getDoubleNumber(num)
    
    if (window.innerWidth < 480) {
      obj.html(num)
      return
    }
    
    let sequence = [
      {
        e: obj,
        p: {scaleX: [0.8, 1], translateY: [-20, 0], opacity: [0, 1]},
        o: {duration: 200, delay: 200, easing: 'easeInQuad', complete: () => obj.html(num)}
      },
      {
        e: obj,
        p: {translateY: [0, 20], opacity: [1, 0], scaleX: [1, 0.8]},
        o: {duration: 200, delay: 200, easing: 'easeOutQuad'}
      },
    ]
    obj.velocity('finish')
    obj.stop(false, true)
    $.Velocity.RunSequence(sequence)
  }
  
  _callSlick (name) {
    $(`.${name}-slider-for`).on('init', () => {
      let obj = $(`.${name}-slider-for`).get(0)
      this._changeTotalNum(this._getDoubleNumber(obj.dataset.total))
      // this.oCurrentNumber.html('01')
      
      window.setTimeout(() => {
        $(`.${name}-slider-nav .my_track`).children('div').eq(0).click()
      }, 200)
    })
    $(`.${name}-slider-for`).on('afterChange', () => {
      try {
        $.fn.fullpage.reBuild()
      } catch (err) {
        
      }
    })
    
    $(`.${name}-slider-for`).on('lazyLoaded', (event, slick, image, imageSource) => {
      $('.lazyloading').velocity('finish').velocity('fadeOut')
    })
    
    $(`.${name}-slider-for`).on('beforeChange', (event, slick, current, nextSlide) => {
      window.__downloadTargetImage = $(slick.$slides[nextSlide]).find('img').get(0)
      $('.lazyloading').velocity('finish').velocity('fadeIn')
      let direction = current > nextSlide ? 'left' : 'right'
      this._changeCurrentNum(nextSlide + 1, direction)
      //  判断是否不需要首行缩进   比如驀然回首
      let notIndent = $(slick.$slides[nextSlide]).attr('notIndent') == 'true' ? true : false
      this._changeDesc($(slick.$slides[nextSlide]).data('desc'), notIndent)
      
      //  修改分享链接
      this._changeShareLink(nextSlide + 1)
      
      let nextSlideObj = $(`.${name}-slider-nav`).find(`div[data-index="${nextSlide + 1}"]`)
      nextSlideObj.addClass('active').siblings().removeClass('active')
      nextSlideObj.velocity('scroll', {
        container: $(`.${name}-slider-nav .my_track`),
        axis: 'x',
        delay: 200,
        easing: 'ease-in-out'
      })
    })
    let prev = window.gp2_is_rtl ? 'slick-next' : 'slick-prev'
    let next = window.gp2_is_rtl ? 'slick-prev' : 'slick-next'
    $(`.${name}-slider-for`).slick({
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      arrows: true,
      cssEase: 'ease-in-out',
      speed: 450,
      dots: false,
      prevArrow: `<button class="${prev} slider-for-button"><img src="${window.gp2_basic_image_path}/focus-point/arrow_left.svg"></button>`,
      nextArrow: `<button class="${next} slider-for-button"><img src="${window.gp2_basic_image_path}/focus-point/arrow_right.svg"></button>`,
      swipe: false,
      rtl: window.gp2_is_rtl,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: window.gp_max_md,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            variableWidth: true,
            swipe: true,
            centerPadding: '20px'
          }
        }
      ]
    })
    $(`.${name}-slider-nav`).children('div').on('click', ev => {
      if ($(ev.currentTarget).hasClass('active')) {
        return
      }
      let obj = ev.currentTarget
      let index = parseInt(obj.dataset.index) - 1
      $(`.${name}-slider-for`).slick('slickGoTo', index)
    })
    $(`.${name}-slider-nav`).children('div').wrapAll('<div class="my_track" />')
    
    $(`.${name}-slider-nav`).prepend(`<button type="button" class="slick-prev slider-nav-button"><img src="${window.gp2_basic_image_path}/focus-images/arrow_small_left.png"></button>`)
    $(`.${name}-slider-nav .slick-prev`).on('click', () => $(`.${name}-slider-for`).slick('slickPrev'))
    $(`.${name}-slider-nav`).append(`<button type="button" class="slick-next slider-nav-button"><img src="${window.gp2_basic_image_path}/focus-images/arrow_small_right.png"></button>`)
    $(`.${name}-slider-nav .slick-next`).on('click', () => $(`.${name}-slider-for`).slick('slickNext'))
  }
  
  /**
   * 初始化Picture slick插件
   */
  callPictureSlick () {
    this._callSlick('picture')
  }
  
  /**
   * 初始化Poster slick插件
   */
  callPosterSlick () {
    this._callSlick('poster')
  }
  
  /**
   * 初始化html
   */
  initHtml () {
    $('.lh-f-i-slick').find('.slider-for').map((i, el) => {
      let oNav = $(el).next()
      el.dataset.total = $(el).find('img').length
      
      //  处理图片
      $(el).find('img').map((_i, _el) => {
        
        // 生成nav 小图 todo 处理找到小的img
        let imgSrc = _el.dataset.lazy
        oNav.append(`<div data-index="${_i + 1}" style="background-image: url('${imgSrc}')"></div>`)
        
        //  包裹div
        let desc = _el.dataset.desc
        let notIndent = $(_el).attr('notIndent')
        desc = desc.replace('"', '&quot;')
        let oDiv = $(`<div data-index="${_i + 1}" notIndent="${notIndent}" class="lh-f-i-item" />`)
        oDiv.data('desc', desc)
        $(_el).wrap(oDiv)
      })
      
    })
    
  }
}

export default focusImages